// Cookie consent service
const COOKIE_CONSENT_KEY = 'cookie_consent';

// Check if user has already given consent
export const hasUserConsent = () => {
  return localStorage.getItem(COOKIE_CONSENT_KEY) !== null;
};

// Get user consent preferences
export const getUserConsentPreferences = () => {
  const consentData = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (!consentData) return null;
  
  try {
    return JSON.parse(consentData);
  } catch (e) {
    console.error('Error parsing cookie consent data:', e);
    return null;
  }
};

// Save user consent
export const saveUserConsent = (preferences) => {
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
    ...preferences,
    timestamp: new Date().toISOString()
  }));
};

// Accept all cookies
export const acceptAllCookies = () => {
  saveUserConsent({
    essential: true,
    functional: true,
    analytics: true,
    marketing: true
  });
};

// Reject non-essential cookies
export const rejectNonEssentialCookies = () => {
  saveUserConsent({
    essential: true,
    functional: false,
    analytics: false,
    marketing: false
  });
};

// Set cookies based on preferences
export const setCookies = (preferences) => {
  // Essential cookies are always enabled, no need to check

  // Here you would implement the actual cookie setting/removing logic
  // based on the preferences object. This is a placeholder that you would 
  // replace with your actual cookie implementation.
  
  if (preferences.functional) {
    // Set functional cookies
  } else {
    // Remove functional cookies
  }
  
  if (preferences.analytics) {
    // Set analytics cookies (like Google Analytics)
  } else {
    // Remove analytics cookies
  }
  
  if (preferences.marketing) {
    // Set marketing cookies
  } else {
    // Remove marketing cookies
  }
};

// Apply the stored cookie preferences
export const applyStoredCookiePreferences = () => {
  const preferences = getUserConsentPreferences();
  if (preferences) {
    setCookies(preferences);
    return true;
  }
  return false;
}; 